import React from 'react';

// import AllReportsDelivered from './AllReportsDelivered';
import ScheduledReports from './ScheduledReports';
import Views from './Views';
import CombinedExportsTable from '../../../components/CombinedExportsTable';

export const getTabPanes = ({
  loading,
  scheduledReports,
  segments,
  scheduledReportsManageParams,
  // reportDeliveries,
  // allReportsManageParams,
  mySavedReports,
  sharedSavedReports,
  manage_params,
  refreshKey,
}) => [
  {
    menuItem: 'All Reports Delivered',
    render: () => (
      <CombinedExportsTable key={refreshKey} />
    ),
  },
  {
    menuItem: 'Scheduled Reports',
    render: () => (
      <ScheduledReports
        loading={loading}
        scheduledReports={scheduledReports}
        segments={segments}
        scheduledReportsManageParams={scheduledReportsManageParams}
      />
    ),
  },
  {
    menuItem: 'My Views',
    render: () => (
      <Views
        loading={loading}
        data={mySavedReports}
        manage_params={manage_params}
      />
    ),
  },
  {
    menuItem: 'Team Views',
    render: () => (
      <Views
        loading={loading}
        data={sharedSavedReports}
        manage_params={manage_params}
      />
    ),
  },
];
